// extracted by mini-css-extract-plugin
module.exports = {"messengersCheckBox":"MessengersCheckbox-module--messengersCheckBox--2nCQj","messengersCheck":"MessengersCheckbox-module--messengersCheck--3eNga"};